import { menoKovania } from "@/lib/format";

/**
 * Pravý názov pomenovaného kovania — malým pod aliasom (KOLO 176). Bez
 * aliasu nič: hlavný nápis už je pravý názov.
 */
export function PravyNazov({
  material,
}: {
  material: { nazov: string; alias?: string | null };
}): JSX.Element | null {
  const { pod } = menoKovania(material);
  if (!pod) return null;
  return (
    <div className="truncate text-xs font-normal text-muted-foreground" title={pod}>
      {pod}
    </div>
  );
}
